import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm, initialize } from 'redux-form';
import { NavLink } from "react-router-dom";
import { SiteWrapper } from "../common";
import { Page, Card, Button, Form, Dimmer, Alert } from "tabler-react";
import { getDepartment, createDepartment, updateDepartment, deleteDepartment } from '../actions';
import { confirmAlert } from 'react-confirm-alert';
import Auth from '../auth/auth';

const auth = new Auth({});

class DepartmentFormPage extends Component {

  componentDidMount() {

    const { id } = this.props.match.params;
    if (id) {
      this.getDepartment(id);
      let alert = localStorage.getItem('createDepartment');
      if (alert) {
        alert = JSON.parse(alert);
        this.setState({ alert });
        localStorage.removeItem('createDepartment');
      }
    }
  }

  constructor(props) {
    super(props);

    this.state = {
      department: {},
      getDepartmentLoader: false,
      submitLoader: false,
      deleteLoader: false,
      alert: {
        display: false,
        type: '',
        icon: '',
        message: ''
      },
    };

    this.renderTextField = this.renderTextField.bind(this);
    this.renderAsterisk = this.renderAsterisk.bind(this);
    this.renderTextAreaField = this.renderTextAreaField.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.handleOnDelete = this.handleOnDelete.bind(this);
  }

  onSubmit(values) {
    console.log('onSubmit', values);
    const { id } = this.props.match.params;
    this.setState({ submitLoader: true });

    if (!id)
    {
      this.props.createDepartment(values, (response) => {
        console.log('createRole', response);
        this.setState({ createDepartment: false });
        localStorage.setItem('createDepartment', JSON.stringify({ display: true, icon: 'check', type: 'success', message: `Department successfully created.` }));
        this.props.history.push(`/departments/${response.data.id}`);
      }, (error) => {
        console.log('createDepartment', error);
        this.setState({ submitLoader: false, alert: { display: true, icon: 'alert-triangle', type: 'danger', message: 'Unable to create new department.' } });
      });
    }
    else
    {
      this.props.updateDepartment(values, (response) => {
        console.log('updateDepartment', response);
        this.setState({ submitLoader: false, alert: { display: true, icon: 'check', type: 'success', message: `Department successfully updated.` }});
      }, (error) => {
        console.log('updateDepartment', error);
        this.setState({ submitLoader: false, alert: { display: true, icon: 'alert-triangle', type: 'danger', message: 'Unable to update department.' } });
      });
    }

  }

  handleOnDelete() {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <Card>
            <Card.Body>
              <h3>Are you sure?</h3>
              <p>You want to delete this department?</p>
              <Button.List>
                <Button type="button" color="secondary" onClick={onClose}>No</Button>
                <Button type="button" color="danger" onClick={() => {
                    this.onDelete();
                    onClose();
                }}>Yes</Button>
              </Button.List>
            </Card.Body>
          </Card>
        )
      }
    });
  }

  onDelete() {
    const { id } = this.props.match.params;
    this.setState({ deleteLoader: true });
    this.props.deleteDepartment(id, (response) => {
      console.log('deleteDepartment', response);
      localStorage.setItem('deleteDepartment', JSON.stringify({ display: true, icon: 'check', type: 'success', message: `Department successfully deleted.` }));
      this.props.history.push(`/departments`);
    }, (error) => {
      console.log('deleteDepartment', error);
      this.setState({ deleteLoader: false, alert: { display: true, icon: 'alert-triangle', type: 'danger', message: 'Unable to delete department.' } });
    });
  }

  getDepartment(id) {
    this.setState({ getDepartmentLoader: true });
    this.props.getDepartment(id, (response) => {
      console.log('getDepartment', response);
      this.props.initialize('DepartmentForm', response.data);
      this.setState({ getDepartmentLoader: false, department: response.data });
    });
  }

  renderAsterisk(isRequired) {
    let asterisk ;
    if (isRequired) asterisk =  <span className="text-danger">*</span>;
    return asterisk;
  }

  renderTextField(field) {
    const { meta: { touched, error }, label, input, isRequired, type, value } = field;
    return (
       <Form.Group>
         {label &&
           <Form.Label>{label} {this.renderAsterisk(isRequired)}</Form.Label>
         }
         <Form.Input
           value={value ? value : ''}
           type={type ? type : 'text'}
           feedback={error}
           invalid={touched && error ? 'invalid' : undefined}
           {...input}
          />
       </Form.Group>
    );
  }

  renderTextAreaField(field) {
    const { meta: { touched, error }, label, input, isRequired, rows } = field;

    return (
       <Form.Group>
         {label &&
           <Form.Label>{label} {this.renderAsterisk(isRequired)}</Form.Label>
         }
         <Form.Textarea
           feedback={error}
           invalid={touched && error ? 'invalid' : undefined}
           {...input}
           rows={rows ? rows : 3}
         />
       </Form.Group>
    );
  }

  renderAlert() {
    return (
      <div>
        {this.state.alert.display &&
          <Alert type={this.state.alert.type} icon={this.state.alert.icon} isDismissible>
            {this.state.alert.message}
          </Alert>
        }
      </div>
    );
  }

  render() {

    const { handleSubmit } = this.props;
    const { id } = this.props.match.params;

    return(
      <SiteWrapper>
          <Page.Content>
            {this.renderAlert()}
            <Form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
              <Card>
                <Card.Header>
                  <Card.Title>
                     {!id ? 'New' : 'Update'} Department
                  </Card.Title>
                </Card.Header>
                <Card.Body>
                  <Dimmer active={this.state.getDepartmentLoader} loader>
                      <div className="row">
                          <div className="col-md-6">
                            <Field label="Name" name="name" isRequired="true" component={this.renderTextField} />
                            <Field label="Description" name="description" component={this.renderTextAreaField} />
                          </div>
                      </div>
                 </Dimmer>
                </Card.Body>
                <Card.Footer>
                  <div className="d-flex">
                    <NavLink to="/departments">
                      <Button color="secondary">Back</Button>
                    </NavLink>
                    {(id && auth.hasAccess('department', 'delete')) &&
                      <Button loading={this.state.deleteLoader} onClick={this.handleOnDelete} className="ml-auto" color="danger" type="button">Delete</Button>
                    }
                    {(!id || auth.hasAccess('department', 'update')) &&
                      <Button loading={this.state.submitLoader} color="success" className={id && auth.hasAccess('department', 'delete') ? 'ml-2' : 'ml-auto'}>Submit</Button>
                    }
                  </div>
                </Card.Footer>
              </Card>
             </Form>
          </Page.Content>
      </SiteWrapper>
    );
  }
}


function validate(values) {
  const errors = {};

  if (!values.name)  {
    errors.name = 'Required Field';
  }

  return errors;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getDepartment, createDepartment, updateDepartment, deleteDepartment, initialize
  }, dispatch);
}

function mapStateToProps(props) {
  return props;
}

export default reduxForm({
  validate,
  form: 'DepartmentForm'
})(connect(mapStateToProps, mapDispatchToProps)(DepartmentFormPage))



// WEBPACK FOOTER //
// ./src/department/department-form.react.js